import React, { createContext } from 'react';
import { IDocumentModalContext, ITabsContext } from '@/types';

export const DropdownContainerContext = createContext<React.RefObject<HTMLDivElement | null> | null>(null);

export const TabsContext = createContext<ITabsContext>({ activeTab: 0 });

export const DocumentModalContext = createContext<IDocumentModalContext>({});
